import { createSelector } from '@ngrx/store';

import { SearchBarState } from '@shared/base-search-bar/store/state/search-bar.state';
import { searchBarSelector } from '@shared/base-search-bar/store/selectors/search-bar.selector';
import { guestsPerRoomAdapter } from '@shared/base-search-bar/store/reducers/guests-per-room.reducer';

const { selectAll } = guestsPerRoomAdapter.getSelectors();

const getGuestsPerRoomState = createSelector(
  searchBarSelector,
  (state: SearchBarState) => state ? state.guestsPerRoom : []
);

export const selectGuestsPerRoom = createSelector(getGuestsPerRoomState, selectAll);
